﻿let $ = require('jquery');
let BreakpointSizer = require('./SizerBreakpoint.js');
let Slideshow = function (customOptions) {
	let defaults = {
		element: null,
		slideSwitchDelay: 4000,
		slideImageSelector: '.jnf-widget-slideshow-photo-container-list .jnf-widget-slideshow-photo-container-list-item',
		firstSlideImageSelector: '.jnf-widget-slideshow-photo-container-list > :first-child',
		firstSlideDescriptionSelector: '.jnf-widget-slideshow-details-list > :first-child',
		arrowLeftSelector: '.jnf-widget-slideshow-arrow.jnf-widget-slideshow-arrow-left',
		arrowRightSelector: '.jnf-widget-slideshow-arrow.jnf-widget-slideshow-arrow-right',
		slidesListSelector: '.jnf-widget-slideshow-photo-container-list',
		slidesÇontainerSelector: '.jnf-widget-slideshow-photo-container',

		progressDotsSelector: '.jnf-widget-slideshow-progress .jnf-widget-slideshow-progress-dot',
		progressDotsSelectedClass: 'jnf-widget-slideshow-progress-dot-active',

		headerSelector: '.jnf-widget-slideshow-header',
		subheaderSelector: '.jnf-widget-slideshow-subheader',
		detailsListSelector: '.jnf-widget-slideshow-details-list',
		detailsListItemSelector: '.jnf-widget-slideshow-details-list-item',

		enabledClass: 'jnf-widget-slideshow-enabled'
	};

	let options = $.extend({}, defaults, customOptions);

	if (options.element === null) {
		throw new Error('element option required');
	}

	new BreakpointSizer({ element: options.element });

	let $element = $(options.element);
	let $slides = $element.find(options.slideImageSelector);
	let $firstSlideImage = $element.find(options.firstSlideImageSelector);
	let $firstSlideDescription = $element.find(options.firstSlideDescriptionSelector);
	let $leftArrow = $element.find(options.arrowLeftSelector);
	let $rightArrow = $element.find(options.arrowRightSelector);
	let slidesLength = $slides.length;
	let $slidesList = $element.find(options.slidesListSelector);
	let $slidesContainer = $element.find(options.slidesÇontainerSelector);
	let $progressDots = $element.find(options.progressDotsSelector);
	let $detailsList = $element.find(options.detailsListSelector);
	let $detailsListItems = $element.find(options.detailsListItemSelector);

	// clone first slide to create an impression of smooth rotation
	$slidesList.append($firstSlideImage.eq(0).clone());
	$detailsList.append($firstSlideDescription.eq(0).clone());

	let selectSlideDot = function (slideRealIndex) {
		$progressDots.removeClass(options.progressDotsSelectedClass);
		$progressDots.eq(slideRealIndex).addClass(options.progressDotsSelectedClass);
	};

	let showDetails = function (slideRealIndex, immediate) {
		$detailsList.stop().fadeOut(function () {
			$detailsListItems.css('visibility', 'hidden').css('left', - slideRealIndex * 100 + '%');
			$detailsListItems.eq(slideRealIndex).css('visibility', 'visible');
		}).fadeIn();

		if (immediate) {
			$detailsList.finish();
		}
	};

	let moveRight = function () {

	    if (Math.round(parseFloat($slidesList.css('left')) / $slidesContainer.width()) * 100 === -currentSlideIndex * 100 ) {

			if (currentSlideIndex < slidesLength) {
				currentSlideIndex++;

				$slidesList.css('left', -currentSlideIndex * 100 + '%');
			} else {
				let originalTransition = $slidesList.css('transition');

				currentSlideIndex = 1;
				$slidesList.css('left', '0%');
				$slidesList.css('transition', 'none');
				$slidesList.height();
				$slidesList.css('left', -currentSlideIndex * 100 + '%');
				$slidesList.css('transition', originalTransition);
			}

			selectSlideDot(currentSlideIndex == slidesLength ? 0 : currentSlideIndex);
			showDetails(currentSlideIndex == slidesLength ? 0 : currentSlideIndex);
	    }
	};

	let moveLeft = function () {

	    if (Math.round(parseFloat($slidesList.css('left')) / $slidesContainer.width()) * 100 === -currentSlideIndex * 100) {

			if (currentSlideIndex == 0) {
				let originalTransition = $slidesList.css('transition');

				currentSlideIndex = slidesLength - 1;
				$slidesList.css('left', -slidesLength * 100 + '%');
				$slidesList.css('transition', 'none');
				$slidesList.height();
				$slidesList.css('left', -currentSlideIndex * 100 + '%');
				$slidesList.css('transition', originalTransition);
			} else {
				currentSlideIndex--;
				$slidesList.css('left', -currentSlideIndex * 100 + '%');
			}

			selectSlideDot(currentSlideIndex == slidesLength ? 0 : currentSlideIndex);
			showDetails(currentSlideIndex == slidesLength ? 0 : currentSlideIndex);
		}
	}

	let onRightClick = function () {
		moveRight();
	};

	let onLeftClick = function () {
	    moveLeft();
	};

	let slideSwitchInterval = null;

	let tryStartRotation = function () {

		if (slideSwitchInterval === null) {
			slideSwitchInterval = setInterval(function () {
				moveRight();
			}, options.slideSwitchDelay);
		}
	};

	let stopRotation = function () {
		clearInterval(slideSwitchInterval);
		slideSwitchInterval = null;
	};

	let onMouseEnter = function () {
		stopRotation();
	};
	
	let onMouseLeave = function () {
		tryStartRotation();
	}

	let currentSlideIndex = 0;

	selectSlideDot(currentSlideIndex);
	showDetails(currentSlideIndex, true);

	if (slidesLength > 1) {
		$rightArrow.on('click', onRightClick);
		$leftArrow.on('click', onLeftClick);
		$element.on('mouseenter', onMouseEnter);
		$element.on('mouseleave', onMouseLeave);

		$element.addClass(options.enabledClass);

		tryStartRotation();
	}
};

module.exports = Slideshow;
